module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    ref: "demoQualifierForm",
    staticClass: "d-flex pa-0",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-space-between align-center pa-0 pr-3",
    attrs: {
      "md": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-subtitle', {
    staticClass: "pa-0 justify-center d-flex align-end"
  }, [_vm._v(" Age Range ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "d-flex justify-space-around pa-0"
  }, [_c('v-row', {
    staticClass: "d-flex justify-space-between"
  }, [_c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ageDemoQualifier",
      "id": "ageDemoQualifier",
      "type": "number",
      "outlined": "",
      "dense": "",
      "hide-details": "true"
    },
    on: {
      "change": _vm.setAgeFrom
    },
    model: {
      value: (_vm.ageFrom),
      callback: function($$v) {
        _vm.ageFrom = $$v
      },
      expression: "ageFrom"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ageDemoQualifier",
      "id": "ageDemoQualifier",
      "type": "number",
      "outlined": "",
      "dense": "",
      "hide-details": "true"
    },
    on: {
      "blur": _vm.setAgeTo
    },
    model: {
      value: (_vm.ageTo),
      callback: function($$v) {
        _vm.ageTo = $$v
      },
      expression: "ageTo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "d-flex pa-0 pt-4"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "error",
      "value": !_vm.valid
    }
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]), _vm._v(" "), _c('v-alert', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "dense": "",
      "text": "",
      "type": "info",
      "value": _vm.info && _vm.valid
    }
  }, [_vm._v("\n            " + _vm._s(_vm.infoMessage) + "\n            "), _c('v-progress-linear', {
    attrs: {
      "value": _vm.infoMessageCounter
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pr-0 d-flex align-center",
    attrs: {
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.genderOptions,
      "label": "Gender",
      "clearable": ""
    },
    on: {
      "change": _vm.setDemoQualifier
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cedea06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/DemoQualifier.vue
// module id = 1961
// module chunks = 0